export const launchSketchTool = (relatedSourceID) =>
    window.open(
        `${process.env.REACT_APP_SKETCH_URL}${relatedSourceID ? `/?RelatedSourceID=${relatedSourceID}` : "/"}`,
        "_blank",
        "noopener,noreferrer",
    );
